import { useState } from 'react';
import { SERVICES } from '../../data/siteData';

export const ServicesExplorer = () => {
  const [active, setActive] = useState(0);
  const s = SERVICES[active];

  const onKeyDown = (e) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    e.preventDefault();
    const next = (active + (e.key === 'ArrowDown' ? 1 : SERVICES.length - 1)) % SERVICES.length;
    setActive(next);
    document.getElementById(`svc-tab-${next}`)?.focus();
  };

  return (
    <div className="svx" data-testid="services-explorer">
      <div className="list" role="tablist" aria-label="Services" aria-orientation="vertical" onKeyDown={onKeyDown}>
        {SERVICES.map((svc, i) => (
          <button
            key={svc.id}
            id={`svc-tab-${i}`}
            type="button"
            role="tab"
            aria-selected={i === active}
            aria-controls="svc-panel"
            tabIndex={i === active ? 0 : -1}
            onClick={() => setActive(i)}
            data-testid={`service-tab-${svc.id}`}
          >
            <span className="code">{String(i + 1).padStart(2, '0')}</span>
            <b>{svc.title}</b>
            <span className="plus" aria-hidden="true">+</span>
          </button>
        ))}
      </div>

      <div className="panel" role="tabpanel" id="svc-panel" aria-labelledby={`svc-tab-${active}`}>
        <div className="img">
          <img key={s.image} className="fade" src={s.image} alt={`${s.title} example model`} />
          <span className="tag">{s.tag}</span>
        </div>
        <div className="body fade" key={s.id}>
          <h3>{s.title}</h3>
          <p>{s.description}</p>
          <ul className="ticks">
            {s.deliverables.map((d) => <li key={d}>{d}</li>)}
          </ul>
          <div className="chips">
            {s.tools.map((t) => <span key={t}>{t}</span>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesExplorer;
